import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import useGarbageCollector from '../../../libs/garbagecollector/garbageCollectorHooks';
import PageBody from '../../components/pagebody/PageBody';
import BatchImport from './batchimport/BatchImport';
import CreateForm from './createform/CreateForm';
import SaveFormSuccess from './createform/createformstepper/saveformsuccess/SaveFormSuccess';
import { componentKey } from './FormsSectionSlice';
import ManageForms from './manageforms/ManageForms';
import Reconciliation from './reconciliation/Reconciliation';
import IrsStateRejected from './irsstaterejected/IrsStateRejected';
import ReviewApproveForms from './reviewapproveforms/ReviewApproveForms';
import ReviewRejectedForms from './reviewrejectedforms/ReviewRejectedForms';
import ResubmitSuccess from './irsstaterejected/federalresubmit/resubmitsuccess/ResubmitSuccess';
import FormSectionLinkButtons from './components/formsectionlinkbuttons/FormSectionLinkButtons';
import SubmitForms from './formslisting/SubmitForms';
import { FEATURE_FLAG } from '../../featureFlags';

export default function FormsSection() {
    useGarbageCollector(componentKey);

    return (
        <PageBody>
            <FormSectionLinkButtons />

            <Routes>
                <Route exact path="/createnew" element={<CreateForm />} />
                <Route exact path="/createnew/success" element={<SaveFormSuccess />} />                
                <Route path="/listing/*" element={<SubmitForms />} />                
                <Route path="/createnew/*" element={<Navigate to={`/forms/createnew`} replace={true} />} />
                <Route path="/import" element={<BatchImport />} />
                <Route path="/manage/*" element={<ManageForms />} />
                <Route exact path="/resubmitsuccess" element={<ResubmitSuccess />} />
                <Route exact path="/irsstaterejected/*" element={<IrsStateRejected />} />
                {FEATURE_FLAG.SHOW_RECONCILIATION && <Route path="/reconciliation/*" element={<Reconciliation />} />}
                <Route path="/import/*" element={<Navigate to={`/forms/import`} replace={true} />} />
                <Route path="/reviewandapprove/*" element={<ReviewApproveForms />} replace={true} />
                <Route path="/reviewrejectedforms/*" element={<ReviewRejectedForms />} replace={true} />    
                <Route path={'/*'} element={<Navigate to={`/forms/listing`} replace={true} />} />  </Routes>
        </PageBody>
    )
}